const PRICE_CONSTANTS = {
  NEW_TAX_PRICE_REQUEST: 'NEW_TAX_PRICE_REQUEST',
  NEW_TAX_PRICE_SUCCESS: 'NEW_TAX_PRICE_SUCCESS',
  NEW_TAX_PRICE_FAIL: 'NEW_TAX_PRICE_FAIL',

  GET_ALL_PRICES_REQUEST: 'GET_ALL_PRICES_REQUEST',
  GET_ALL_PRICES_SUCCESS: 'GET_ALL_PRICES_SUCCESS',
  GET_ALL_PRICES_FAIL: 'GET_ALL_PRICES_FAIL',

  UPDATE_TAX_PRICE_REQUEST: 'UPDATE_TAX_PRICE_REQUEST',
  UPDATE_TAX_PRICE_SUCCESS: 'UPDATE_TAX_PRICE_SUCCESS',
  UPDATE_TAX_PRICE_FAIL: 'UPDATE_TAX_PRICE_FAIL',
  RESET_UPDATE_PRICE: 'RESET_UPDATE_PRICE',

  DELETE_TAX_PRICE_REQUEST: 'DELETE_TAX_PRICE_REQUEST',
  DELETE_TAX_PRICE_SUCCESS: 'DELETE_TAX_PRICE_SUCCESS',
  DELETE_TAX_PRICE_FAIL: 'DELETE_TAX_PRICE_FAIL',

  CLEAR_ERRORS: 'CLEAR_ERRORS',
}

export default PRICE_CONSTANTS
